import * as Sentry from '@sentry/react';
import { AxiosError } from 'axios';

const HANDLED_ERROR_TYPES = ['not_found', 'unauthorized', 'forbidden'];

function initSentry() {
  // Skip Sentry in local dev regardless of VITE_ENVIRONMENT value
  if (import.meta.env.DEV) return;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    environment: import.meta.env.VITE_ENVIRONMENT,
    tracesSampleRate: import.meta.env.VITE_ENVIRONMENT === 'production' ? 0.1 : 1.0,
    beforeSend(event, hint) {
      const error = hint.originalException;

      if (typeof error === 'string' && HANDLED_ERROR_TYPES.includes(error)) {
        return null;
      }

      if (error instanceof AxiosError) {
        const status = error.response?.status;

        if (status && status >= 400 && status < 500) {
          return null;
        }

        if (status && status >= 500) {
          event.contexts = {
            ...event.contexts,
            axios: {
              method: error.config?.method,
              url: error.config?.url,
              status,
              statusText: error.response?.statusText,
            },
          };
        }
      }

      return event;
    },
    ignoreErrors: ['Network request failed', 'Failed to fetch'],
  });
}

initSentry();
